import React, {useCallback} from 'react';
import './LeaveEmpty.css';
import {Button} from "@chakra-ui/react";
import {WarningIcon} from "@chakra-ui/icons";

const CensimentoDim = (props) => {
    return (
        <Button leftIcon={<WarningIcon />} className={'leave_btn'} {...props}>Censimento Explorer</Button>
    );
};

export default CensimentoDim;
